import type { IconProps } from './types';

export const H2Icon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M14.4641 19.261C14.4642 18.1969 15.0947 17.2335 16.0696 16.8069L18.9309 15.555L19.0774 15.4778C19.4036 15.2737 19.6066 14.9141 19.6067 14.5218C19.6067 13.8986 19.1019 13.393 18.4788 13.3929H17.1428C16.6308 13.3929 16.1936 13.7202 16.0315 14.179C15.8934 14.5692 15.4648 14.7737 15.0745 14.636C14.6841 14.498 14.4787 14.0694 14.6165 13.679C14.9838 12.6396 15.9754 11.8929 17.1428 11.8929H18.4788C19.9303 11.893 21.1067 13.0701 21.1067 14.5218C21.1066 15.5007 20.5636 16.3925 19.7073 16.845L19.5325 16.93L16.6702 18.1819C16.2415 18.3697 15.9642 18.793 15.9641 19.261V19.6067H20.3567L20.4338 19.6106C20.8119 19.649 21.1065 19.9686 21.1067 20.3567C21.1067 20.745 20.812 21.0644 20.4338 21.1028L20.3567 21.1067H15.2141C14.8 21.1066 14.4641 20.7709 14.4641 20.3567V19.261ZM10.6067 17.7854V11.4641H4.39282V17.7854C4.39282 18.1996 4.05704 18.5354 3.64282 18.5354C3.22861 18.5354 2.89282 18.1996 2.89282 17.7854V3.64286C2.89282 3.22864 3.22861 2.89286 3.64282 2.89286C4.05704 2.89286 4.39282 3.22864 4.39282 3.64286V9.96415H10.6067V3.64286C10.6067 3.22878 10.9427 2.89308 11.3567 2.89286C11.7709 2.89286 12.1067 3.22864 12.1067 3.64286V17.7854C12.1067 18.1996 11.7709 18.5354 11.3567 18.5354C10.9427 18.5352 10.6067 18.1995 10.6067 17.7854Z"
        fill={color}
      />
    </svg>
  );
};
